export const createDateRangeParams = ({ dateStart, dateEnd } = {}) => {
  const params = new URLSearchParams()

  if (dateStart && dateEnd) {
    params.append('filter[date_start]', dateStart)
    params.append('filter[date_end]', dateEnd)
  }

  return params
}
